import React from "react";
import PropTypes from "prop-types";

import Textfield from "@atlaskit/textfield";
import LinkIcon from "@atlaskit/icon/glyph/link";

import { FieldLabel } from "./styled/Components";

const LinkIconContainer = ({ children }) => (
  <div style={{ height: "26px", width: "24px", paddingLeft: "4px" }}>
    {children}
  </div>
);

function TextInput({
  label,
  placeholder,
  value,
  setValue,
  isLink = false,
  type = "text",
  style,
}) {
  return (
    <div style={style}>
      {label !== "" && <FieldLabel>{label}</FieldLabel>}
      <Textfield
        type={type}
        elemBeforeInput={
          isLink ? (
            <LinkIconContainer>
              <LinkIcon primaryColor="#07145a" />
            </LinkIconContainer>
          ) : (
            <></>
          )
        }
        placeholder={placeholder || ""}
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="elementor-textinput"
      />
    </div>
  );
}

TextInput.defaultProps = {
  placeholder: "",
  style: {},
  isLink: false,
  label: "",
  type: "text",
};

TextInput.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string.isRequired,
  setValue: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  style: PropTypes.object,
  isLink: PropTypes.bool,
  type: PropTypes.string,
};

export default TextInput;
